/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import AcademicProgramCertificate from '../model/AcademicProgramCertificate';
import DigitalCertificateRequest from '../model/DigitalCertificateRequest';
import Error from '../model/Error';
import InlineResponse2007 from '../model/InlineResponse2007';

/**
* Certificates service.
* @module api/CertificatesApi
* @version 1.0.0
*/
export default class CertificatesApi {

    /**
    * Constructs a new CertificatesApi. 
    * @alias module:api/CertificatesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get certificates available for an academic program
     * @param {Number} academicProgramId Academic Program ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/AcademicProgramCertificate>} and HTTP response
     */
    certificatesControllerGetAcademicProgramCertificatesWithHttpInfo(academicProgramId) {
      let postBody = null;
      // verify the required parameter 'academicProgramId' is set
      if (academicProgramId === undefined || academicProgramId === null) {
        throw new Error("Missing the required parameter 'academicProgramId' when calling certificatesControllerGetAcademicProgramCertificates");
      }

      let pathParams = {
        'academicProgramId': academicProgramId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [AcademicProgramCertificate];
      return this.apiClient.callApi(
        '/account/certificates/academic-programs/{academicProgramId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get certificates available for an academic program
     * @param {Number} academicProgramId Academic Program ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/AcademicProgramCertificate>}
     */
    certificatesControllerGetAcademicProgramCertificates(academicProgramId) {
      return this.certificatesControllerGetAcademicProgramCertificatesWithHttpInfo(academicProgramId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * get
     * get filtred presta certificates
     * @param {Number} academicProgramId Academic Program ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/InlineResponse2007>} and HTTP response
     */
    certificatesControllerGetPrestaCertificatesWithHttpInfo(academicProgramId) {
      let postBody = null;
      // verify the required parameter 'academicProgramId' is set
      if (academicProgramId === undefined || academicProgramId === null) {
        throw new Error("Missing the required parameter 'academicProgramId' when calling certificatesControllerGetPrestaCertificates");
      }

      let pathParams = {
        'academicProgramId': academicProgramId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [InlineResponse2007];
      return this.apiClient.callApi(
        '/account/students/student/{academicProgramId}/presta/certificates', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * get
     * get filtred presta certificates
     * @param {Number} academicProgramId Academic Program ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/InlineResponse2007>}
     */
    certificatesControllerGetPrestaCertificates(academicProgramId) {
      return this.certificatesControllerGetPrestaCertificatesWithHttpInfo(academicProgramId)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Request a digital certificate for an academic program
     * @param {Number} academicProgramId Academic Program ID
     * @param {module:model/DigitalCertificateRequest} digitalCertificateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
    certificatesControllerRequestAcademicProgramCertificateWithHttpInfo(academicProgramId, digitalCertificateRequest) {
      let postBody = digitalCertificateRequest;
      // verify the required parameter 'academicProgramId' is set
      if (academicProgramId === undefined || academicProgramId === null) {
        throw new Error("Missing the required parameter 'academicProgramId' when calling certificatesControllerRequestAcademicProgramCertificate");
      }
      // verify the required parameter 'digitalCertificateRequest' is set
      if (digitalCertificateRequest === undefined || digitalCertificateRequest === null) {
        throw new Error("Missing the required parameter 'digitalCertificateRequest' when calling certificatesControllerRequestAcademicProgramCertificate");
      }

      let pathParams = {
        'academicProgramId': academicProgramId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/account/certificates/academic-programs/{academicProgramId}/request', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Request a digital certificate for an academic program
     * @param {Number} academicProgramId Academic Program ID
     * @param {module:model/DigitalCertificateRequest} digitalCertificateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
    certificatesControllerRequestAcademicProgramCertificate(academicProgramId, digitalCertificateRequest) {
      return this.certificatesControllerRequestAcademicProgramCertificateWithHttpInfo(academicProgramId, digitalCertificateRequest)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
